import React from "react";
import { useField } from "formik";
import { Textarea } from "@jsq/ds/core";
import { FormTextInput } from "@jsq/ds/forms";
import { FieldGroup } from "../../../../../common/components/Form/Layout/FieldGroup";
import { MultiInputFormRow } from "../../../../../common/components/Form/Layout/MultiInputFormRow";
import { SimpleFormRow } from "../../../../../common/components/Form/Layout/SimpleFormRow";
import { isUSA } from "../../../../../common/utils";
import { SharedAddressInput } from "../../../../SharedAddressInput";
import { getNameFromCountry } from "../../../mappers";
import { ADDITIONAL_INSTRUCTIONS_MAX_LENGTH, AccountDetailsInputFields } from "./constants";
import { EftAddressCountrySelect } from "./EftAddressCountrySelect";

const AdditionalInstructionsTextarea: React.FC = () => {
  const [field, meta] = useField(AccountDetailsInputFields.AdditionalInstructions);

  return (
    <Textarea
      {...field}
      label="Additional instructions"
      isFullWidth
      size="small"
      maxLength={ADDITIONAL_INSTRUCTIONS_MAX_LENGTH}
      helpText="Optional"
      errorMessage={meta.touched && meta.error ? meta.error : undefined}
    />
  );
};

export const AccountDetails: React.FC = () => {
  return (
    <FieldGroup title="Account details">
      <SimpleFormRow>
        <FormTextInput
          label="Account holder name"
          isFullWidth
          name={AccountDetailsInputFields.AccountName}
        />
      </SimpleFormRow>
      <MultiInputFormRow>
        <FormTextInput
          label="Account number"
          isFullWidth
          name={AccountDetailsInputFields.AccountNumber}
        />
        <FormTextInput
          label="Confirm account number"
          isFullWidth
          name={AccountDetailsInputFields.ConfirmAccountNumber}
        />
      </MultiInputFormRow>
      <SharedAddressInput
        title="Account holder address"
        meta={{ headerType: "strong-md" }}
        CountrySelect={EftAddressCountrySelect}
        testIsUSA={(country) => isUSA(getNameFromCountry(country))}
      />
      <SimpleFormRow>
        <AdditionalInstructionsTextarea />
      </SimpleFormRow>
    </FieldGroup>
  );
};
